import { Component, OnInit } from '@angular/core';
import ILoading from '../../_interfaces/ILoading';
import { LoadingService } from '../../_services/loading/loading.service';

@Component({
  standalone: true,
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit {
  public payload: ILoading = {
    isLoading: false,
    message: undefined,
  };

  constructor(private loadingService: LoadingService) {}
  ngOnInit(): void {
    this.loadingService.isLoading$().subscribe((payload: ILoading) => {
      this.payload = payload;
    });
  }
}
